// const URL = {
//   conferense: "http://sql:5000/wpu/conference/data/all",
//   transport: "http://sql:5000/wpu/transport/data/all",
//   phones: "http://sql:5000/wpu/phones/data/all",
//   users:"http://sql:5000/wpu/users/data/all"
// };

// const URL = {
//   conferense: "http://172.25.0.23:5000/wpu/conference/data/all",
//   transport: "http://172.25.0.23:5000/wpu/transport/data/all",
//   phones: "http://172.25.0.23:5000/wpu/phones/data/all",
//   users:"http://172.25.0.23:5000/wpu/users/data/all"
// };

const URL = {
    conference: "./data/bublicData.json",
    transport: "http://172.25.3.26:5000/wpu/transport/data/all",
    phones: "http://172.25.3.26:5000/wpu/phones/data/all",
    users:"http://172.25.3.26:5000/wpu/users/data/all"
  };

// const URL = {
//   conferense: "http://localhost:5000/wpu/conference/data/all",
//   transport: "http://localhost:5000/wpu/transport/data/all",
//   phones: "http://localhost:5000/wpu/phones/data/all",
//   users:"http://localhost:5000/wpu/users/data/all"
// };

export default URL;
